import React from "react";
import JobSafetyDesktop from "../../EnvironmentHealthSafety/JobSafety/JobSafetyDesktop";
import { UniqueImpactProps } from "./UniqueImpact";

const UniqueImpactDesktop: React.FC<UniqueImpactProps> = ({ ...props }) => {
	return <JobSafetyDesktop {...props} />;
};

export default UniqueImpactDesktop;
